import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';

const navLinks = [
  { label: 'Über uns', sectionId: 'about' },
  { label: 'Leistungen', sectionId: 'features' },
  { label: 'Referenzen', sectionId: 'projects' },
  { label: 'Kontakt', sectionId: 'contact' },
];

const Header = ({ scrollToSection }) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [compact, setCompact] = useState(false);
  const [hiddenOnMobile, setHiddenOnMobile] = useState(false);

  useEffect(() => {
    let lastScrollY = window.scrollY;
    let ticking = false;

    const handleScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const currentScrollY = window.scrollY;
        setCompact(currentScrollY > 20);

        const isMobile = window.innerWidth <= 760;
        const delta = currentScrollY - lastScrollY;
        const suppressMobileHeader = isMobile && performance.now() < (window.__eosSuppressMobileHeaderUntil || 0);
        if (suppressMobileHeader) {
          setHiddenOnMobile(true);
          lastScrollY = currentScrollY;
          ticking = false;
          return;
        }

        if (!isMobile || mobileOpen || currentScrollY < 80) {
          setHiddenOnMobile(false);
        } else if (delta > 8) {
          setHiddenOnMobile(true);
        } else if (delta < -8) {
          setHiddenOnMobile(false);
        }

        lastScrollY = currentScrollY;
        ticking = false;
      });
    };

    handleScroll();
    const handleMagnetScroll = () => {
      if (window.innerWidth <= 760 && !mobileOpen) setHiddenOnMobile(true);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('eos:mobile-reference-magnet', handleMagnetScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('eos:mobile-reference-magnet', handleMagnetScroll);
    };
  }, [mobileOpen]);

  const handleNavClick = (sectionId) => {
    scrollToSection?.(sectionId);
    setMobileOpen(false);
  };

  return (
    <header className={`eos-experience-header ${hiddenOnMobile ? 'is-mobile-hidden' : ''}`}>
      <div className={`eos-experience-topbar ${compact ? 'is-compact' : ''}`}>
        <div className="eos-experience-bar-inner">
          <button
            type="button"
            className="eos-experience-brand"
            onClick={() => handleNavClick('hero')}
            aria-label="Startseite"
          >
            <img src="/EOS-Energy-Systems-Logo_hell.png" alt="EOS Energy Systems" />
            <span>EOS Energy Systems</span>
          </button>

          <nav className="eos-experience-mainnav" aria-label="Hauptnavigation">
            {navLinks.map((link) => (
              <button
                key={link.sectionId}
                type="button"
                onClick={() => handleNavClick(link.sectionId)}
              >
                {link.label}
              </button>
            ))}
          </nav>

          <button
            type="button"
            className="eos-experience-top-cta"
            onClick={() => handleNavClick('contact')}
          >
            Projekt starten
          </button>

          <button
            type="button"
            onClick={() => setMobileOpen((prev) => !prev)}
            className="eos-experience-mobile-toggle"
            aria-label={mobileOpen ? 'Menü schließen' : 'Menü öffnen'}
          >
            {mobileOpen ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="eos-experience-mobile-menu">
          {navLinks.map((link) => (
            <button
              key={link.sectionId}
              type="button"
              onClick={() => handleNavClick(link.sectionId)}
            >
              {link.label}
            </button>
          ))}
          <a href="tel:+4915168581912">+49 151 6858 1912</a>
        </div>
      )}
    </header>
  );
};

export default Header;
